import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import { Container, Alert, Spinner, Button } from 'react-bootstrap';

const NewsletterUnsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  // A abertura da ligação apenas valida o token. O cancelamento só acontece
  // quando a pessoa carrega no botão: os clientes de email e os scanners
  // anti-phishing seguem as ligações sozinhos e cancelavam subscrições.
  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Token não encontrado');
        return;
      }

      try {
        const response = await axiosInstance.get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`);
        setStatus(response.alreadyUnsubscribed ? 'success' : 'confirm');
        setMessage(response.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Erro ao cancelar a newsletter');
      }
    };

    checkToken();
  }, [token]);

  const handleConfirm = async () => {
    setStatus('submitting');
    try {
      const response = await axiosInstance.post('/newsletter/unsubscribe', { token });
      setStatus('success');
      setMessage(response.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Erro ao cancelar a newsletter');
    }
  };

  return (
    <Container className="mt-5">
      {(status === 'loading' || status === 'submitting') && (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">A carregar...</span>
          </Spinner>
          <p className="mt-2">
            {status === 'submitting' ? 'A processar o teu cancelamento...' : 'A validar a tua ligação...'}
          </p>
        </div>
      )}

      {status === 'confirm' && (
        <Alert variant="warning" className="text-center">
          <h4>Cancelar a subscrição</h4>
          <p>{message}</p>
          <Button variant="danger" onClick={handleConfirm}>
            Confirmar cancelamento
          </Button>
        </Alert>
      )}

      {status === 'success' && (
        <Alert variant="success" className="text-center">
          <h4>Sucesso!</h4>
          <p>{message}</p>
        </Alert>
      )}

      {status === 'error' && (
        <Alert variant="danger" className="text-center">
          <h4>Erro</h4>
          <p>{message}</p>
        </Alert>
      )}
    </Container>
  );
};

export default NewsletterUnsubscribe;
